import { ReactNode } from 'react';

const SectionFrame = ({ children }: { children: ReactNode }) => (
	<div
		style={{
			display: 'flex',
			flexDirection: 'column',
			gap: '48px',
			margin: 'auto',
		}}
	>
		{children}
	</div>
);

export default SectionFrame;
